import React, {forwardRef, useMemo} from 'react';
import {FakeHoursInputStyle} from '../../../../../shared/components/inputs/hours-input/hours_input_styled';
import {convertIntoFloatHoursFormat} from '../../../../../shared/components/inputs/hours-input/hours_input_logic';
import {useIntl} from 'react-intl';
import styled from 'styled-components';
import {PopoverHandler} from '@forecast-it/design-system';

type IconWrapperProps = {
	onlyShowIconOnHover?: boolean;
};

const IconWrapper = styled.div<IconWrapperProps>`
	opacity: ${({onlyShowIconOnHover}) => (onlyShowIconOnHover ? '0' : '1')};
`;

const StyledHoursInputButton = styled(FakeHoursInputStyle)`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0;
	margin-right: 6px;

	&:hover ${IconWrapper} {
		opacity: 1;
	}

	[data-state='open'] & {
		border-color: #6e0fea;
	}
`;

const HoursInput = styled.div`
	padding: 6px 15px 6px 0;
`;

type HoursInputButtonProps = {
	children: JSX.Element;
	title: string | null;
	minutesRegistered: number | null | undefined;
	disabled: boolean;
	nonWorkingDay: boolean;
	onlyShowIconOnHover?: boolean;
};

const getValueInFloatHoursFormat_timeRegInputConversion = (minutesRegistered, intl) => {
	const hasValue = minutesRegistered != null && !isNaN(minutesRegistered);
	if (hasValue) {
		return convertIntoFloatHoursFormat(`${minutesRegistered}m`, intl, 0, false, true);
	}
	return '';
};

const HoursInputButton = forwardRef<HTMLButtonElement, HoursInputButtonProps>(
	({children, title, minutesRegistered, disabled, nonWorkingDay, onlyShowIconOnHover}, ref): JSX.Element => {
		const {open, setOpen} = PopoverHandler.usePopoverState();
		const toggle = () => setOpen(!open);
		const intl = useIntl();

		const value = useMemo(() => {
			return getValueInFloatHoursFormat_timeRegInputConversion(minutesRegistered, intl);
		}, [minutesRegistered]);

		return (
			<StyledHoursInputButton
				data-cy={'hours-input-popup-toggle'}
				title={title || ''}
				disabled={disabled}
				className={nonWorkingDay ? 'non-working-day' : ''}
				onClick={toggle}
				ref={ref}
			>
				<IconWrapper onlyShowIconOnHover={onlyShowIconOnHover}>{children}</IconWrapper>
				<HoursInput>{value.full}</HoursInput>
			</StyledHoursInputButton>
		);
	}
);

export default HoursInputButton;
